export const getLogin = (refIFrame) => {
  const iframeItem = refIFrame.current;
  iframeItem.contentWindow.postMessage(
    JSON.stringify({ method: "get_login" }),
    "*"
  );
};
